import React from 'react';
import { SvgIcon } from '@mui/material';

export default function HistoryBookIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path fill="#2563eb" d="M6 2h13a1 1 0 0 1 1 1v17a2 2 0 0 1-2 2H6a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3Z" />
      <path fill="#1e40af" d="M6 2h1v16H6a3 3 0 0 0-3 3V5a3 3 0 0 1 3-3Z" />
      <path fill="#dbeafe" d="M6 18h13v3H6a1.5 1.5 0 0 1 0-3Z" />
      <path fill="#fbbf24" d="M14 2h3v8l-1.5-1L14 10Z" />
      <path fill="none" stroke="#bfdbfe" strokeLinecap="round" strokeWidth="1.5" d="M10 12h6m-6 3h4" />
    </SvgIcon>
  );
}
